<template>
    <div v-if="previewUrl" class="py-1">
        <img
            :src="previewUrl"
            :alt="field.name"
            class="h-10 w-10 rounded object-cover"
        >
    </div>
    <span v-else>&mdash;</span>
</template>

<script>
export default {
    props: ['resourceName', 'field'],

    computed: {
        /**
         * Preview URL for the stored image.
         *
         * @returns {string|null}
         */
        previewUrl() {
            return this.field.previewUrl || null
        },
    },
}
</script>
